import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettingsUrl } from '../appSettings';
import { Observable } from 'rxjs';

export interface IPlan {
    id: number;
    name: string;
    tickers: number;
    setups: number;
    tickersBatch: number;
    tickersPerBatch: number;
    setupsBatch: number;
    setupsPerBatch: number;
    tickersCountDiscount: number;
    tickersCountDiscountSize: number;
    //targetFilter: number;
    active: boolean;
    duration: number;
    durationPrice: number;
    durationType: number;
    repetition: number;
    userId?: number;
    forPromo: boolean;
}


export interface IAmbassadorPlan {
    title: string;
    table: IAmbassadorTable;
}

export interface IAmbassadorTable {
    columns: IAmbassadorCellItem[];
    rows: IAmbassadorRows[];
}

export interface IAmbassadorRows {
    cells: IAmbassadorCellItem[];
}

export interface IAmbassadorCellItem {
    type: "text"|"number"|"$"|"subscribe"|"link";
    value: string;
    colSpan: number;
    bold:boolean;
    href:string;
}

@Injectable()
export class PlanService {

    private API_URL: string = AppSettingsUrl.apiUrl;
    constructor(private http: HttpClient) { }

    public getPlans = (refId?: string): Observable<IPlan[]> =>
        this.http.get<IPlan[]>(`${this.API_URL}usercall/getuserplans/${refId}`);

    public getAmbassadorPlans = (planName: string): Observable<IAmbassadorPlan[]> =>
        this.http.get<IAmbassadorPlan[]>(`./assets/ambassador/${planName}?salt=${Date.now()}`);

}
